import Vue from 'vue'
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import App from './App.vue'

import {Howl, Howler} from 'howler';

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

import { store } from "./store/store";
import { routes } from './routes';
import { i18n } from "./i18n.js";

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  mode: "history"
});

new Vue({
  el: '#app',
  store,
  router,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js